import {
  Checkbox,
  FormField,
  Modal,
  TextInput,
  Variants,
} from "@sede-enterprise/shell-ds-react-framework";
import {
  IExchangeConfig,
  BidProductTypeEnum,
  ExchangeTypeEnum,
} from "../../services";
import styled from "styled-components";
import { useAppDispatch } from "../../store";
import { useState } from "react";
import { PostExchangeConfigAction } from "../../store/ExchangeConfig/ActionCreator";
import { defaultOptions } from "highcharts";
import DropDownList, {
  IDictionary,
} from "../../components/DropDownList/DropDownList";

const ColumnDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  gap: 10px;
`;

const CheckboxStyled = styled(Checkbox)`
  margin-top: 24px;
`;

interface IExchangeConfigEntityProps {
  exchangeConfig: IExchangeConfig;
  onCancel: () => void;
}

export const EditExchangeConfigEntity = ({
  exchangeConfig,
  onCancel,
}: IExchangeConfigEntityProps) => {
  const dispatch = useAppDispatch();
  const open = true;
  const convertExchangeIdToName = (exchangeId: string) => {
    return exchangeId === "1" ? ExchangeTypeEnum.Jao : ExchangeTypeEnum.Empire;
  };
  const convertExchangeNameToId = (exchangename: string) => {
    return exchangename === ExchangeTypeEnum.Jao ? "1" : "2";
  };
  const [corridorCode, setCorridorCode] = useState<string>(
    exchangeConfig.corridorCode?.toString()
  );
  const [exchangeId, setExchangeId] = useState<string>(
    exchangeConfig.exchangeId?.toString()
  );
  const [inAreaEicCode, setInAreaEicCode] = useState<string>(
    exchangeConfig.inAreaEicCode?.toString()
  );
  const [outAreaEicCode, setOutAreaEicCode] = useState<string>(
    exchangeConfig.outAreaEicCode?.toString()
  );
  const [productType, setProductType] = useState<string>(
    exchangeConfig.productType?.toString()
  );
  const [key, setKey] = useState<string>(exchangeConfig.key?.toString());
  const [keyValue, setKeyValue] = useState<string>(
    exchangeConfig.value?.toString()
  );
  const [isActive, setIsActive] = useState<boolean>(
    exchangeConfig.isActive?.valueOf()
  );

  const changeCorridorCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCorridorCode(e.target.value);
  };
  const changeKeyValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyValue(e.target.value);
  };
  const changeKey = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKey(e.target.value);
  };
  const changeInAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInAreaEicCode(e.target.value);
  };
  const changeOutAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOutAreaEicCode(e.target.value);
  };

  const changeExchangeId = (exchangeId: string) => {
    setExchangeId(convertExchangeNameToId(exchangeId));
  };
  const p = defaultOptions;
  const isString = (str: string) => !!str?.length;
  const validate = () => {
    if (!isString(keyValue) || !isString(key)) {
      return false;
    }
    return true;
  };
  const onConfirm = () => {
    if (validate()) {
      dispatch(CreateOrUpdateExchangeConfig());
      onCancel();
    }
  };

  const CreateOrUpdateExchangeConfig = () => {
    return PostExchangeConfigAction({
      id: exchangeConfig.id,
      corridorCode: corridorCode,
      exchangeId: exchangeConfig.exchangeId,
      createdDateTime: exchangeConfig.createdDateTime,
      updatedDateTime: new Date(),
      outAreaEicCode: outAreaEicCode,
      inAreaEicCode: inAreaEicCode,
      productType: productType,
      isActive: isActive,
      key: key,
      value: keyValue,
    } as IExchangeConfig);
  };

  const productTypes = () => {
    let dictionary: IDictionary[] = [];
    let products = Object.keys(BidProductTypeEnum).map((x) => {
      return {
        key: x,
        value: x,
      } as IDictionary;
    });
    return products || dictionary;
  };
  const [products] = useState<IDictionary[]>(productTypes());

  const exchangeNames = () => {
    let dictionary: IDictionary[] = [];
    let exchanges = Object.values(ExchangeTypeEnum).map((x) => {
      return {
        key: x,
        value: x,
      } as IDictionary;
    });
    return exchanges || dictionary;
  };
  const [exchanges] = useState<IDictionary[]>(exchangeNames());
  //Include crossOrigin prop to overcome the compilation error
  return (
    <div>
      <Modal
        title={`EDIT - Exchange Configs`}
        open={open}
        onClose={onCancel}
        actions={[
        {
          label: "Cancel",
          action: onCancel,
          props: {
            variant: Variants.Outlined
          }
        },
        {
          label: "Save",
          action: onConfirm
        }
      ]}
      >
        <form>
          <ColumnDiv>
            <FormField id="exchangeIdFormField" label="Exchange">
              <DropDownList
                content={exchanges}
                placeholder="Select Exchange"
                value={convertExchangeIdToName(exchangeId)}
                allowClear={false}
                onSelect={changeExchangeId}
                disabled={true}
                width="100%"
              ></DropDownList>
            </FormField>
            <FormField id="isActive">
              <CheckboxStyled
                label="Active"
                onChange={() => setIsActive(!isActive)}
                checked={isActive}
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField
              id="keyFormField"
              label="Key"
              description={!isString(key) ? "Please enter a valid Key" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="keyTextInputTextInput"
                onChange={changeKey}
                value={key}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="keyValueFormField"
              label="Value"
              description={
                !isString(keyValue) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="keyValueTextInput"
                onChange={changeKeyValue}
                value={keyValue}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField id="corridorCodeFormField" label="Corridor Code">
              <TextInput
                aria-labelledby="input"
                id="corridorCodeTextInput"
                value={corridorCode}
                onChange={changeCorridorCode}
              />
            </FormField>
            <FormField id="productTypeFormField" label="Product Type">
              <DropDownList
                content={products}
                placeholder="Select Product"
                value={productType}
                allowClear={false}
                onSelect={(e: any) => setProductType(e)}
                disabled={false}
                width="100%"
              ></DropDownList>
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField id="inAreaEicCodeFormField" label="In Area Eic Code">
              <TextInput
                aria-labelledby="input"
                id="inAreaEicCodeTextInput"
                onChange={changeInAreaEicCode}
                value={inAreaEicCode}
                autoComplete="off"
              />
            </FormField>
            <FormField id="outAreaEicCodeFormField" label="Out Area Eic Code">
              <TextInput
                aria-labelledby="input"
                id="outAreaEicCodeTextInput"
                onChange={changeOutAreaEicCode}
                value={outAreaEicCode}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
        </form>
      </Modal>
    </div>
  );
};
export default EditExchangeConfigEntity;
